import InputForm from './InputForm';
import SelectForm from './SelectForm';
import InputNumberForm from './InputNumberForm';
import CascaderForm from './Cascader';
import DateForm from './DateForm';
import TreeSelectForm from './TreeSelectForm';
export const getMessage = (type = 1) => {
    let message = {
        1: '请输入',
        2: '请选择',
        3: '请输入',
        4: '请选择',
        5: '请选择',
        6: '请选择',
        10: '请选择'
    };
    return message[type];
};
import { rules } from 'grt-tool-lib-front';
const { checkIsIdentity } = rules;

//验证规则
export const getRules = (props) => {
    const { field_type = 1, setting = {} } = props,
        rules = [],
        [min = 0, max = 100] = setting?.number_range || [];
    if (props.required === 0) {
        rules.push({ required: true, message: getMessage(props.field_type) });
    }
    //文本类型 --当前仅有文本类型有其他的规则限制
    if (field_type === 1 && setting.type !== 'tag') {
        if (setting.maxLength) {
            if (props.en_name === 'name') {
                // 名称仅支持中英文、数字，且不超过 maxLength 个字
                rules.push({
                    validator: (_, value) => {
                        if (!value) {
                            return Promise.resolve();
                        }
                        const reg = new RegExp(`^[\\u4e00-\\u9fa5a-zA-Z0-9]{1,${setting.maxLength}}$`);
                        if (!reg.test(String(value).trim())) {
                            return Promise.reject({ field: props.en_name, message: `支持${setting.maxLength}个字以内的中英文数字` });
                        }
                        return Promise.resolve();
                    }
                });
            } else {
                rules.push({ max: setting.maxLength, message: `最多输入${setting.maxLength}字` });
            }
        }
    }
    //数值类型：输入时不判断范围，失焦及提交时统一校验
    if (field_type === 3) {
        const { allow_negative = 0, decimal_places = 2 } = setting || {},
            formatMsg = `数值格式不匹配，${allow_negative === 1 ? '允许' : '不允许'}负数，${Number(decimal_places) > 0 ? `支持 ${decimal_places} 位小数` : '不支持小数'}`;
        rules.push({
            validator: (_, value) => {
                // 空值交由 required 规则处理
                if (value === '' || value === null || value === undefined) {
                    return Promise.resolve();
                }
                const num = Number(value);
                // 非数字，或不允许负数时输入了负数
                if (isNaN(num) || (num < 0 && allow_negative !== 1)) {
                    return Promise.reject(new Error(formatMsg));
                }
                // 小数位超出配置位数
                const valueStr = String(value),
                    dotIndex = valueStr.indexOf('.'),
                    decimalLen = dotIndex === -1 ? 0 : valueStr.length - dotIndex - 1;
                if (decimalLen > decimal_places) {
                    return Promise.reject(new Error(formatMsg));
                }
                // 范围校验
                if (num < min) {
                    return Promise.reject(`数值范围不能小于${min}`);
                }
                if (num > max) {
                    return Promise.reject(`数值范围不能大于${max}`);
                }
                return Promise.resolve();
            }
        });
    }
    if (props.en_name === 'id_card') {
        rules.push({
            validator: (_, value) => {
                if (!value) {
                    return Promise.resolve();
                }
                return checkIsIdentity(value).catch(() => {
                    return Promise.reject({ field: props.en_name, message: '请输入正确的身份证号' });
                });
            }
        });
    }

    return rules;
};
//根据类型 选择不同的表单  // 1-文本 2-下拉 3-数值 4-级联 5-日期 6 -上传
export const getForm = (props) => {
    let { field_type = 1 } = props;
    switch (field_type) {
        case 2:
            return SelectForm(props);
        case 3:
            return InputNumberForm(props);
        case 4:
            return CascaderForm(props);
        case 5:
            return DateForm(props);
        case 7:
            return TreeSelectForm(props);
        default:
            return InputForm(props);
    }
};
